module.exports = __webpack_public_path__ + "img/fob_pin_red.b4048525.svg";